// extracted by mini-css-extract-plugin
module.exports = {"tooltip-content":"tooltip_tooltip-content__1Mxjd","scaleIn":"tooltip_scaleIn__Yudss"};